<template>
    <a
        v-show="text"
        href="#"
        class="js-tooltip tooltip-span icon-tooltip"
        data-toggle="tooltip"
        title=""
        :data-original-title="text"
    >
        <icon-base
            type="icon"
            name="help"
            :additional-css-classes="`${color ? 'icon--default icon--' + color : 'icon--default'}`"
        />
    </a>
</template>
<script>
import {defineComponent} from "vue";
import IconBase from "@/components/IconBase";

export default defineComponent({
    name: 'Tooltip',
    components: {IconBase},
    props: {
        text: String,
        color: String
    },
});
</script>
